import request from "../service/index";
import {
	PayParams,
	buyData,
	buyItem,
	leagueData,
	loginByTelegramData,
	loginByWalletData,
	recommendData,
	resultData,
	searchData,
} from "./type";
class API {
	static members = {
		// 获取登录随机nonce
		postLoginNonce: (data: any) => {
			return request({
				url: "/member/api/user/login/nonce",
				method: "POST",
				data,
			});
		},
		// 钱包快捷登录
		userLoginByWallet: (data: loginByWalletData) => {
			return request({
				url: "/member/api/user/loginByWallet",
				method: "POST",
				data,
			});
		},
		// console快捷登录
		userLoginByConsole: (data: loginByWalletData) => {
			return request({
				url: "/member/api/user/loginByConsole",
				method: "POST",
				data,
			});
		},
		// telegram快捷登录
		userLoginByTelegram: (data: loginByTelegramData) => {
			return request({
				url: "/member/api/user/loginByTelegram",
				method: "POST",
				data,
			});
		},
		// 获取用户信息
		getUserInfo: (data: any) => {
			return request({
				url: "/member/api/user/info",
				method: "GET",
				data,
			});
		},
		// 获取上级代理
		getSuperiorAgent: () => {
			return request({
				url: "/member/api/user/invite/console",
				method: "GET",
			});
		},
		// 修改分成比例 scale
		postUserSetingUpdate: (data: any) => {
			return request({
				url: "/member/api/user/setting/update",
				method: "POST",
				data,
			});
		},
		// 申请当庄
		postUserAgentApply: (data: any) => {
			return request({
				url: "/member/api/user/agent/apply",
				method: "POST",
				data,
			});
		},
		// 给下级用户设置备注
		postUserAgentInviteRemake: (data: any) => {
			return request({
				url: "/member/api/user/invite/update",
				method: "POST",
				data,
			});
		},
		// 添加下级为管理员,此接口可实现更新权限和删除管理员
		postUserAgentInviteRole: (data: any) => {
			return request({
				url: "/member/api/user/agent/invite/role",
				method: "POST",
				data,
			});
		},
		// 查询当前代理设置的管理员列表
		postUserAgentManagerList: (data: any) => {
			return request({
				url: "/member/api/user/agent/manager/list",
				method: "GET",
				data,
			});
		},
		// 添加玩法返水比例
		postUserWaterPlanOperation: (data: any) => {
			return request({
				url: "/member/api/user/water/plan/operation",
				method: "POST",
				data,
			});
		},
		postUserUpdate: (data: any) => {
			return request({
				url: "/member/api/user/update",
				method: "POST",
				data,
			});
		},
		postInviteCodeRecord: (data: any) => {
			return request({
				url: "/member/api/user/invite/record",
				method: "POST",
				data,
			});
		},
		postInviteRecordList: (data: any) => {
			return request({
				url: "/member/api/user/invite/record/list",
				method: "POST",
				data,
			});
		},
		postInviteRecordRemark: (data: any) => {
			return request({
				url: "/member/api/user/invite/record/remark",
				method: "POST",
				data,
			});
		},
	};
	static games = {
		// 获取游戏列表(新的)
		apiGetGameList: (data: any) => {
			return request({
				url: "/game/api/app/gameList",
				method: "GET",
				data,
			});
		},
		// 获取游戏列表(六神的)
		apiGetBannerGames: (data: any) => {
			return request({
				url: "/game/api/app/getBannerGames",
				method: "GET",
				data,
			});
		},
		// 首页栏目
		apiGetGames: (data: any) => {
			return request({
				url: "/game/api/app/getGames",
				method: "GET",
				data,
			});
		},
		// 游戏搜索
		apiGetGameSerch: (data: any) => {
			return request({
				url: "/game/api/app/searchGame",
				method: "GET",
				data,
			});
		},
		// 获取游戏地址(新的)
		apiGetGameUrl: (data: any) => {
			return request({
				url: "/game/api/app/gameUrl",
				method: "POST",
				data,
			});
		},
		apiGetGameHall: (data: any) => {
			return request({
				url: "/game/api/app/gameHall",
				method: "GET",
				data,
			});
		},
		// 检测游戏健康心跳
		apiCheckGame: () => {
			return request({
				url: "/game/api/app/game/check",
				method: "GET",
				noTip: true,
			});
		},
		// 获取赛事推荐数据
		apiMatchRecommend: (data: any) => {
			return request({
				url: "/game/api/fb/match/recommend",
				method: "GET",
				data,
			});
		},
		// 获取赛事汇总
		apiMatchStatistical: (data: any) => {
			return request({
				url: "/game/api/fb/match/statistical",
				method: "GET",
				data,
			});
		},
		// 赛事列表数据
		apiMatchGetList: (data: recommendData) => {
			return request({
				url: "/game/api/fb/match/getList",
				method: "POST",
				data,
			});
		},
		// 根据赛事ID获取赛事信息
		apiMatchInfo: (data: any) => {
			return request({
				url: "/game/api/fb/match/info",
				method: "GET",
				data,
			});
		},
		//获取所有/推荐联赛数据
		apiMatchLeague: (data: leagueData) => {
			return request({
				url: "/game/api/fb/match/league",
				method: "POST",
				data,
			});
		},
		// 根据搜索条件搜索赛事
		apiMatchSearch: (data: searchData) => {
			return request({
				url: "/game/api/fb/match/search",
				method: "POST",
				data,
			});
		},
		// 获取赛事赛果
		apiMatchResult: (data: resultData) => {
			return request({
				url: "/game/api/fb/match/result",
				method: "POST",
				data,
			});
		},
		// 体育下注
		apiOrderBuy: (data: buyData) => {
			return request({
				url: "/game/api/order/buy",
				method: "POST",
				data,
			});
		},
		// 订单记录
		apiOrderItem: (data: buyItem) => {
			return request({
				url: "/game/api/order/item",
				method: "POST",
				data,
			});
		},
		//
		apiAppSignIn: (data: buyItem) => {
			return request({
				url: "/game/api/app/sign/in",
				method: "GET",
				data,
			});
		},
		// 获取初始化配置
		apiAppConfig: (data: buyItem) => {
			return request({
				url: "/game/api/app/config",
				method: "GET",
				data,
			});
		},
		// 获取广告,type支持多类型(同时获取多个用,此种请求不支持数量) 1/开屏 2/banner 3/弹窗 4/我的页面banner
		apiAppBanner: (data: any) => {
			return request({
				url: "/game/api/app/banner",
				method: "GET",
				data,
			});
		},
		// 根据赛事阵容信息
		apiAppMatchPlayer: (data: any) => {
			return request({
				url: "/game/api/fb/match/player",
				method: "GET",
				data,
			});
		},
		// 文件上传
		apiAppUploadFile: (data: any) => {
			return request({
				url: "/game/api/app/upload/file",
				method: "POST",
				data,
			});
		},
		// 获取比赛队伍的历史交锋和对阵
		apiAppMatchHistoryResult: (data: any) => {
			return request({
				url: "/game/api/fb/match/history/result",
				method: "GET",
				data,
			});
		},
		// 获取指定赛事的改变事件
		apiAppFbMatchChange: (data: any) => {
			return request({
				url: "/game/api/fb/match/change",
				method: "POST",
				data,
			});
		},
		// 获取游戏公告
		apiGetGameNotice: (data: any) => {
			return request({
				url: "/game/api/app/game/notice",
				method: "GET",
				data,
			});
		},
	};
	static finances = {
		apiAppConfig: (data: buyItem) => {
			return request({
				url: "/finance/api/agent/config",
				method: "GET",
				data,
			});
		},
		// 刷新用户信息
		apiFinanceBalance: (data: any) => {
			return request({
				url: "/finance/api/finance/balance",
				method: "POST",
				data,
			});
		},
		// 用户个人资料
		apiFinanceUserDash: (data: any) => {
			return request({
				url: "/finance/api/finance/user/dash",
				method: "GET",
				data,
			});
		},
		// 获取用户资金记录 分页必传 src/status/startTime/endTime itemType/账户类型: 1/系统金币 2/充值 3/可提
		apiFinanceOrderList: (data: any) => {
			return request({
				url: "/finance/api/finance/order/list",
				method: "POST",
				data,
			});
		},
		// 获取充值渠道(新的)
		apiPayChannel: () => {
			return request({
				url: "/finance/api/pay/channel",
				method: "GET",
			});
		},
		// 正常充值和USDT充值(新)
		apiFinancePayOrder: (data: any) => {
			return request({
				url: "/finance/api/pay/order",
				method: "POST",
				data,
			});
		},
		// 查询某个订单的状态 || 查询待支付订单
		apiFinancePayOrderItem: (data: any) => {
			return request({
				url: "/finance/api/finance/pay/order/item",
				method: "POST",
				data,
			});
		},
		// 获取提现订单记录
		apiFinanceCashOrderItem: (data: any) => {
			return request({
				url: "/finance/api/finance/cash/order/item",
				method: "POST",
				data,
			});
		},
		// 充值订单撤销
		apiFinancePayOrderCancel: (data: any) => {
			return request({
				url: "/finance/api/pay/order/cancel",
				method: "GET",
				data,
			});
		},
		// 获取提现收款列表
		apiFinanceCashAddress: (data: any) => {
			return request({
				url: "/finance/api/finance/cash/address",
				method: "GET",
				data,
			});
		},
		// 提现收款操作
		apiFinanceCashaAdressOperation: (data: any) => {
			return request({
				url: "/finance/api/finance/cash/address/operation",
				method: "POST",
				data,
			});
		},
		// 用户提现
		apiFinanceUserCash: (data: any) => {
			return request({
				url: "/finance/api/finance/user/cash",
				method: "POST",
				data,
			});
		},
		// 查询代理首页
		apiFinanceAgentHome: () => {
			return request({
				url: "/finance/api/agent/home",
				method: "GET",
			});
		},
		// 代理管理员finance首页
		apiFinanceAgentHomeFinace: (data: any) => {
			return request({
				url: "/finance/api/agent/home/finance",
				method: "POST",
				data,
			});
		},
		// 代理管理员members页
		apiFinanceAgentHomeMember: (data: any) => {
			return request({
				url: "/finance/api/agent/home/member",
				method: "POST",
				data,
			});
		},
		// 查询代理下用户的相关记录
		apiFinanceOrderRecords: (data: any) => {
			return request({
				url: "/finance/api/agent/member/order/records",
				method: "POST",
				data,
			});
		},
		// 查询下级用户列表 包含金额那些
		apiFinanceAccountMemberSearch: (data: any) => {
			return request({
				url: "/finance/api/agent/member/search",
				method: "POST",
				data,
			});
		},
		// 代理给下级用户预存
		apiFinanceAgentDeposit: (data: any) => {
			return request({
				url: "/finance/api/finance/agent/deposit",
				method: "POST",
				data,
			});
		},
		// 用户领取返水金额
		apiFinanceWaterReceive: (data: any) => {
			return request({
				url: "/finance/api/finance/water/receive",
				method: "GET",
				data,
			});
		},
		// 发起支付
		apiFinanceAgentPay: (data: PayParams) => {
			return request({
				url: "/finance/api/agent/pay/any",
				method: "POST",
				data,
				noTip: true,
			});
		},
		// 获取代理返水记录
		apiFinanceAgentCommission: (data: any) => {
			return request({
				url: "/finance/api/agent/home/commission",
				method: "POST",
				data,
				noTip: true,
			});
		},
		// 提取分佣
		apiFinanceAgentCommissionReceive: () => {
			return request({
				url: "/finance/api/finance/cpmmission/receive",
				method: "GET",
			});
		},
		// 获取代理下级用户列表
		apiFinanceAgentList: (data: any) => {
			return request({
				url: "/finance/api/agent/list",
				method: "POST",
				data,
			});
		},
		// 流水列表
		apiFinanceOrderWaterList: (data: any) => {
			return request({
				url: "/finance/api/finance/orderWater/list",
				method: "POST",
				data,
			});
		},
	};
	/* 登录 */
	static postAppLogin = (data: any) => {
		return request({
			url: "/api/login",
			method: "POST",
			data,
		});
	};
}

export default API;
